import { Card, CardHeader } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState, useContext } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ChartComponent from "./ChartComponent"; // Ensure this component is created to handle chart rendering
import Loader from "layouts/loader/loader";
import AccountingApi from "Classes/API/AccountingApi";
import SearchAccountingEntriesReq from "Classes/Models/Requests/Accounting/SearchAccountingEntriesReq";
import Icon from "@mui/material/Icon";
import { LanguageContext } from "App";
import { Dashboard } from "@mui/icons-material";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
const AccountingEntryStatistics = () => {
  const { translations } = useContext(LanguageContext);
  const [loading, setLoading] = useState(false);
  const [statistics, setStatistics] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const fetchAccountingEntryStatistics = async () => {
    try {
      setLoading(true);
      let req = new SearchAccountingEntriesReq();
      req.fromDate = fromDate;
      req.toDate = toDate;
      const res = await AccountingApi.GetAccountingEntryStatistics(req);
      if (res.status === "Success") {
        setStatistics(res.data);
        console.log(res.data);
      } else {
        setStatistics({});
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching accounting entry statistics:", error);
      setLoading(false);
      setStatistics({});
    }
  };

  useEffect(() => {
    fetchAccountingEntryStatistics();
  }, []);

  const formatChartData = (data, isExpense = false) => {
    if (!data) return { labels: [], datasets: [] };
    const values = Object.values(data).map((value) => (isExpense ? Math.abs(value) : value));
    return {
      labels: Object.keys(data),
      datasets: [
        {
          label: "Amount",
          data: values,
          backgroundColor: !isExpense ? "rgba(54, 162, 235, 0.5)" : "rgba(255, 206, 86, 0.5)",
          borderColor: !isExpense ? "rgba(54, 162, 235, 1)" : "rgba(255, 206, 86, 1)",
          borderWidth: 1,
        },
      ],
    };
  };
  // const formatChartData = (data) => {
  //   if (!data) return { labels: [], datasets: [] };

  //   // Process values to determine colors
  //   const values = Object.values(data);
  //   const backgroundColors = values.map(value =>
  //     value >= 0 ? "rgba(54, 162, 235, 0.5)" : "rgba(255, 206, 86, 0.5)"
  //   );
  //   const borderColors = values.map(value =>
  //     value >= 0 ? "rgba(54, 162, 235, 1)" : "rgba(255, 206, 86, 1)"
  //   );

  //   return {
  //     labels: Object.keys(data),
  //     datasets: [
  //       {
  //         label: "Amount",
  //         data: values,
  //         backgroundColor: backgroundColors,
  //         borderColor: borderColors,
  //         borderWidth: 1,
  //       },
  //     ],
  //   };
  // };

  const handleSearch = () => {
    fetchAccountingEntryStatistics();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar/>
      <Card style={{ boxShadow: "0 5px 13px rgb(0 0 0 / 0.2)" }} mb={3} id="SearchPackagesStats">
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            {translations.StasticsFeedbackFilterAccountingEntriesbyDate}
          </MDTypography>
        </MDBox>

        <form id="SearchPackagesStatsForm">
          <MDBox p={3}>
            <MDBox
              borderRadius="lg"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={2}
            >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-4 ">
                    <DatePicker
                      showIcon
                      toggleCalendarOnIconClick
                      selected={fromDate}
                      onChange={(date) => setFromDate(date)}
                      placeholderText={translations.StasticsFeedbackStartDate}
                      isClearable
                    />
                  </div>
                  <div className="col-md-4 ">
                    <DatePicker
                      showIcon
                      toggleCalendarOnIconClick
                      selected={toDate}
                      onChange={(date) => setToDate(date)}
                      placeholderText={translations.StasticsFeedbackEndDate}
                      isClearable
                    />
                  </div>
                  <div className="col-md-4 align-content-center">
                    <MDButton
                      onClick={handleSearch}
                      sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                      color="info"
                    >
                      <Icon sx={{ fontWeight: "bold" }}>search</Icon>
                      &nbsp;{translations.StasticsFeedbackGetStatistics}
                    </MDButton>
                  </div>
                </div>
              </div>
            </MDBox>
          </MDBox>
        </form>
      </Card>

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#ff6384" }}>
                  <CardHeader title={translations.StasticsFeedbackTotalIncome} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    EGP{" "}
                    {statistics?.totalIncome
                      ? new Intl.NumberFormat().format(statistics.totalIncome)
                      : "N/A"}
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-4">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#ffce56" }}>
                  <CardHeader title={translations.StasticsFeedbackTotalExpenses} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    EGP{" "}
                    {statistics?.totalExpenses
                      ? new Intl.NumberFormat().format(statistics.totalExpenses)
                      : "N/A"}
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-4">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#36a2eb" }}>
                  <CardHeader title={translations.StasticsFeedbackProfitMargin} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    EGP{" "}
                    {statistics?.profitMargin
                      ? new Intl.NumberFormat().format(statistics.profitMargin)
                      : "N/A"}
                  </MDBox>
                </Card>
              </div>
            </div>
          </div>

          <div className="container" style={{ display: "flex", flexDirection: "column" }}>
            <div className="row" style={{ display: "flex", flex: 1 }}>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackMonthlyIncome} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent chartData={formatChartData(statistics?.monthlyIncome)} />
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackMonthlyExpenses} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent
                      chartData={formatChartData(statistics?.monthlyExpenses, true)}
                    />
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackCategoryBreakdownIncome} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent
                      chartData={formatChartData(statistics?.categoryBreakdownIncome)}
                    />
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackCategoryBreakdownExpenses} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent
                      chartData={formatChartData(statistics?.categoryBreakdownExpenses, true)}
                    />
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackTopRevenueSources} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent chartData={formatChartData(statistics?.topRevenueSources)} />
                  </MDBox>
                </Card>
              </div>
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default AccountingEntryStatistics;
